import { Event, EventListener } from "./Event";
import { Layout } from "../components/layout/Layout";

export interface LayoutLoadListener extends EventListener<LayoutLoadEvent> {
}

export class LayoutLoadEvent extends Event<Layout> {
    constructor(target: Layout) {
        super(target);
    }

    public get layout(): Layout {
        return this.target;
    }
}
